import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';

import { PageHeader, Breadcrumbs, WysiwygField } from '../../../../components';

import './style.scss';

const NodeLandingPage = ({ entity, className }) => {
  const front = entity.get('is_front');
  const classes = classNames(className, 'LandingPage', {
    'front-page': front,
  });
  const hasFilter = entity.getIn(['field_has_filters', 0, 'value'], false);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <PageHeader className={hasFilter ? 'with-filter' : false}>
        {!front ? (
          <Breadcrumbs includeCurrent />
        ) : null}
        <h1 className="PageHeader__title">{entity.getIn(['title', 0, 'value'])}</h1>
        {entity.getIn(['body', 0, 'processed']) ? (
          <WysiwygField
            property="schema:text"
            className="sub-title"
            html={entity.getIn(['body', 0, 'processed'], '')}
          />
        ) : null}
      </PageHeader>
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      ) : null}
    </article>
  );
};

export default NodeLandingPage;
